/**
 * Created by Mikhail Menshenin on 19.08.2024
 */

const CoinSlotMachineSymbolView = cc.Node.extend({
    ctor: function (symbol) {
        this._super();

        this.symbol = symbol;
        this.reel = this.symbol.reel;

        const styles = cleverapps.styles.CoinSlotMachineSymbolView;

        this.setContentSize2(styles);
        this.setAnchorPoint(0.5, 0.5);

        const icon = this.icon = new cc.Sprite(symbol.icon);
        this.addChild(icon);
        icon.setAlignment(this.width / 2, this.height / 2);

        if (symbol.sliding_icon) {
            const slidingIcon = this.slidingIcon = new cc.Sprite(symbol.sliding_icon);
            this.addChild(slidingIcon);
            slidingIcon.setAlignment(this.width / 2, this.height / 2);
            slidingIcon.setVisible(false);
        }

        symbol.on("move", this.move.bind(this), this);
        symbol.on("spin", this.spinOneDegree.bind(this), this);
        symbol.on("reset", this.reset.bind(this), this);

        this.setAlignment(this.calcPosition());

        this.setCascadeColorEnabled(true);
    },

    reset: function () {
        this.stopAllActions();

        if (this.shine) {
            this.shine.removeFromParent();
            delete this.shine;
        }

        this.setColor(cleverapps.styles.COLORS.WHITE);
    },

    move: function () {
        this.setAlignment(this.calcPosition());
    },

    spinOneDegree: function (duration, isFast, isLast) {
        const styles = cleverapps.styles.CoinSlotMachineSymbolView;
        const targetPos = this.calcPosition();

        if (this.slidingIcon) {
            this.icon.setVisible(!isFast);
            this.slidingIcon.setVisible(isFast);
        }

        if (isLast) {
            this.runAction(new cc.Sequence(
                new cc.MoveBy(duration / 1000, 0, -styles.height * 9 / 8).easing(cc.easeBackOut(0.1)),
                cleverapps.effects.fireAction("slotmachine.stop"),
                new cc.CallFunc(() => {
                    this.setAlignment(targetPos);
                })
            ));
        } else {
            this.runAction(new cc.Sequence(
                new cc.MoveBy(duration / 1000, 0, -styles.height),
                new cc.CallFunc(() => {
                    this.setAlignment(targetPos);
                })
            ));
        }
    },

    calcPosition: function () {
        const styles = cleverapps.styles.CoinSlotMachineSymbolView;

        const bottomSymbolIndex = (this.reel.getCurrent().index + 1) % this.reel.symbols.length;
        const indexOffset = (bottomSymbolIndex - this.symbol.index + this.reel.symbols.length) % this.reel.symbols.length;

        const centerOffset = cleverapps.styles.CoinSlotMachineReelView.height / 2 - (styles.height / 2 + styles.height);

        return cc.p(this.width / 2, styles.height / 2 + indexOffset * styles.height + centerOffset);
    }
});

cleverapps.styles.CoinSlotMachineSymbolView = {
    width: 145,
    height: 145
};